//#region src/utils/themeTokens.ts
const format = (channels, alpha) => alpha === void 0 ? `rgb(${channels})` : `rgb(${channels} / ${alpha})`;
/**
* A semantic `--*` token as the `rgb(...)` the browser currently computes on `<html>`.
*
* - For consumers that need a concrete colour string, not a Tailwind class.
* - Falls back to `fallbackChannels` with no document or undefined token (tests load no CSS).
*/
const resolveToken = (token, fallbackChannels, alpha) => {
	const channels = typeof document === "undefined" ? fallbackChannels : getComputedStyle(document.documentElement).getPropertyValue(`--${token}`).trim() || fallbackChannels;
	return format(channels, alpha);
};
/** A token reader bound to one `getComputedStyle` snapshot, answering the raw `"R G B"` channels. */
const createChannelResolver = (from) => {
	const element = from ?? (typeof document === "undefined" ? null : document.documentElement);
	const computed = element === null ? null : getComputedStyle(element);
	return (token, fallbackChannels) => computed?.getPropertyValue(`--${token}`).trim() || fallbackChannels;
};
//#endregion
export { createChannelResolver, resolveToken };

//# sourceMappingURL=themeTokens-l2Fsfcs7.js.map